<template>
  <div>
    <div v-if="folwid2 != ''">
      <div>
        <el-table :data="tabledata" style="width: 100% ;heifht:80%;">
          <el-table-column prop="qishu" label="期数"> </el-table-column>
          <el-table-column prop="payMoney" label="应扣金额(单位:元)"> </el-table-column>
          <el-table-column prop="agreementNo" label="订单号"> </el-table-column>
          <el-table-column prop="outTradeNo" label="outTradeNo"> </el-table-column>
          <el-table-column prop="userTuid" label="userTuid"> </el-table-column>
          <el-table-column prop="aaaaa" label="代扣时间"> </el-table-column>
          <el-table-column prop="jieguo" label="状态"> </el-table-column>
          <el-table-column prop="tips" label="取消原因"> </el-table-column>
          <el-table-column fixed="right" label="操作" width="160">

            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div class="anniu">
                <el-button @click="quxiao(scope.row)" type="primary" size="small">取消该笔代扣</el-button>
              </div>
              <div class="anniu">
                <el-button @click="dktk(scope.row)" type="success" size="small">代扣退款</el-button>
              </div>
              <!-- <div class="anniu">
                <el-button @click="tkdetail(scope.row)" type="info" size="small">查询退款情况</el-button>
              </div> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog title="取消原因" :visible.sync="dialogTableVisible1" width="40%" :before-close="dialogTableVisible1">
        <div style="margin:25px 0">
          <el-input placeholder="取消原因" v-model="tips"></el-input> <br>
        </div>
        <el-button @click="dialogTableVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="queding5()">确 定</el-button>
      </el-dialog>

      <div v-if="tabledata != ''">
        <div class="bzfw">蚂蚁链回传数据/代扣</div>
        <el-table :data="hadata" style="width: 100% ;heifht:80%;">
          <el-table-column prop="user_id" label="	id"> </el-table-column>
          <el-table-column prop="user_name" label="	姓名"> </el-table-column>
          <el-table-column prop="process_status" label="	状态"> </el-table-column>
          <el-table-column prop="create_time" label="	本条数据产生时间"> </el-table-column>
          <el-table-column prop="withholding_time" label="	应代扣时间"> </el-table-column>
          <el-table-column prop="withholding_amount" label="	应代扣金额(元)"> </el-table-column>
          <el-table-column prop="alipay_transaction_number" label="	代扣执行单号"> </el-table-column>
        </el-table>
      </div>
    </div>

    <div v-else>
      <div class="baoqian1">抱歉,暂时没有信息! <div class="myl">请先签署蚂蚁链代扣合同！</div> </div>
    </div>
  </div>
</template>
  
<script>
import FengkongApi from "@/api/fengkong.js";
import Table from '../../product/product/part/spec/many/Table.vue';
export default {
  components: { Table },
  props: ["folwid2", "myloid"],
  data() {
    return {
      tips:"",
      outTradeNo: '',
      folwid: '',
      hadata: [],
      dialogTableVisible1: false,
      jieguo: '',
      qishu: '',
      aaaaa: '',
      tabledata: [],
    };
  },
  created() {
    let self = this;
    // self.folwid2 = self.folwid2
    // console.log("folwid2",self.folwid2)
    if (!self.folwid2) {
      return
    }
    let qishu = 1;
    let Params = { flowId: self.folwid2 };

    FengkongApi.daikouguize(Params, true)
      .then((data) => {
        self.fkdata = JSON.parse(data.data.data.responseData);
        self.tips = self.fkdata.payRules.tips
        self.tabledata = self.fkdata.payRules
        for (let i = 0; i < self.tabledata.length; i++) {
          let xunhuan = self.tabledata[i]
          let date = new Date(xunhuan.payDate);
          //时间戳为10位需*1000，时间戳为13位的话不需乘1000
          let y = date.getFullYear();
          let MM = date.getMonth() + 1;
          MM = MM < 10 ? ('0' + MM) : MM; //月补0
          let d = date.getDate();
          d = d < 10 ? ('0' + d) : d; //天补0
          let h = date.getHours();
          h = h < 10 ? ('0' + h) : h; //小时补0
          let m = date.getMinutes();
          m = m < 10 ? ('0' + m) : m; //分钟补0
          let s = date.getSeconds();
          s = s < 10 ? ('0' + s) : s; //秒补0
          var aaaaa = y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
          self.tabledata[i].aaaaa = aaaaa;
          self.tabledata[i].qishu = qishu;
          qishu++;
          self.tabledata[i].payMoney = self.tabledata[i].payMoney / 100;
          // console.log("状态", self.tabledata[i].status)
          let zhen = self.tabledata[i]
          if (zhen.status == 'PAY_TOBE_TRIGGER') {
            zhen.status = '未触发扣款状态'
          } else if (zhen.status == 'PAY_TRIGGERING') {
            zhen.status = '准备扣款状态，临时状态'
          }
          else if (zhen.status == 'WAIT_BUYER_PAY') {
            zhen.status = '扣款中状态'
          }
          else if (zhen.status == 'PAY_SYNC_TRADE_SUCCESS') {
            zhen.status = '扣款中状态'
          }
          else if (zhen.status == 'TRADE_CLOSED') {
            zhen.status = '扣款失败并距离预期扣款时间超过365天'
          }
          else if (zhen.status == 'TRADE_SUCCESS') {
            zhen.status = '扣款成功'
          }
          else if (zhen.status == 'PAY_FAIL') {
            zhen.status = '扣款失败'
          }
          else if (zhen.status == 'TRADE_FINISHED') {
            zhen.status = '交易终止不允许退款,距离交易成功超过180天,自动变为终结态'
          }
          else if (zhen.status == 'TRADE_CANCEL') {
            zhen.status = '代扣取消，终结态'
          }
          self.tabledata[i].jieguo = zhen.status;
        }

      })
      .catch((error) => {
      });


    FengkongApi.mayiliandaikouhui(Params, true)
      .then(data => {
        let self = this;
        self.hadata = data.data.list.data
        self.folwid = data.data.list.data.folwid
        for (let j = 0; j < data.data.list.data.length; j++) {
          let huichuan = data.data.list.data[j]
          let withholding_time = Number(huichuan.withholding_time);
          let date1 = new Date(withholding_time);
          //时间戳为10位需*1000，时间戳为13位的话不需乘1000
          let y1 = date1.getFullYear();
          let MM1 = date1.getMonth() + 1;
          MM1 = MM1 < 10 ? ('0' + MM1) : MM1; //月补0
          let d1 = date1.getDate();
          d1 = d1 < 10 ? ('0' + d1) : d1; //天补0
          let h1 = date1.getHours();
          h1 = h1 < 10 ? ('0' + h1) : h1; //小时补0
          let m1 = date1.getMinutes();
          m1 = m1 < 10 ? ('0' + m1) : m1; //分钟补0
          let s1 = date1.getSeconds();
          s1 = s1 < 10 ? ('0' + s1) : s1; //秒补0
          var timedata = y1 + '-' + MM1 + '-' + d1 + ' ' + h1 + ':' + m1 + ':' + s1;
          data.data.list.data[j].withholding_time = timedata;
          let withholding_amount = huichuan.withholding_amount / 100;
          data.data.list.data[j].withholding_amount = withholding_amount;
        }
      })
      .catch(error => { });

  },

  methods: {
    dktk(row) {
      console.log("代扣退款", row.outTradeNo, row.payMoney, this.folwid2, this.myloid);
      this.$confirm('确定代扣退款吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info '
      }).then(() => {
        let Params = {
          flowid: this.folwid2,
          order_id: this.myloid,
          outtradeno: row.outTradeNo,
          refundamount: row.payMoney * 100
        };
        FengkongApi.withholdingRefund(Params, true)
          .then((data) => {
            console.log(data);
            this.$message({
              message: "操作成功",
              type: "success",
            });
          })
          .catch((error) => {
            this.$message({
              message: "操作失败",
              type: "warning",
            });
          });

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 查询退款情况
    // tkdetail(row){
    //   console.log(row);
    // },
    quxiao(row) {
      let self = this;
      self.dialogTableVisible1 = true;
      self.outTradeNo = row.outTradeNo
    },
    /*备注弹窗确定*/
    queding5() {
      let self = this
      console.log(
        self.folwid2
      )
      let Params = {
        cancelOutOrderNo: self.outTradeNo,
        flowId: self.folwid2,
        tips : self.tips
      };
      FengkongApi.quxiaotiaomu(Params, true).then((data) => {
            console.log(data);
            if(data.code == 1){
              this.$message({
                message: "操作成功",
                type: "success",
              });
            }
            this.dialogTableVisible1 = false;
          })
          .catch((error) => {
            this.$message({
              message: "操作失败",
              type: "warning",
            });
          });
    },


  },
};
</script>
  
<style>
.bzfw {
  background-color: #A894A6;
  color: white;
  padding: 5px 10px;
  width: 140px;
  text-align: center;
}

.baoqian1 {
  font-size: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}

.myl {
  font-size: 25px;
  color: red;
}
</style>
  


// WEBPACK FOOTER //
// src/views/fengkong/operation/detail3.vue